// src/App.js

import React, { useState, useEffect } from "react";
import "./App.css";

import NavBar from "./components/NavBar";
import Home from "./components/Home";
import Portal from "./components/Portal";
import Footer from "./components/Footer";
import Contact from "./components/Contact";
import Info from './components/Info';
import Especialidades from './components/Especialidades';
import Cobertura from './components/Cobertura'; 
import Consultorios from './components/Consultorios';

function App() {
  const [activePage, setActivePage] = useState("home");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [activePage]);

  const navigateTo = (page) => {
    setActivePage(page);
  };

  return (
    <div className="app">
      <NavBar onNavigate={navigateTo} activePage={activePage} />

      
      {activePage === 'info' ? (
        <Info />
      ) : (
        <main className="app-content">
          {activePage === "home" && <Home />}
          {activePage === "portal" && <Portal />}
          {activePage === "contact" && <Contact />}
          {activePage === "especialidades" && <Especialidades />}
           {activePage === "cobertura" && <Cobertura />}
            {activePage === "consultorios" && <Consultorios />}
        </main>
      )}
      
      <Footer />
    </div>
  );
}

export default App;